const DEFAULT_COLLECTION_TITLES = new Set(['Recipe Collection', 'Recipe Book']);

const firstNameFrom = (value) => {
  const firstWord = String(value || '').trim().split(/\s+/)[0];
  return firstWord || '';
};

const possessiveName = (name) => {
  if (!name) return '';
  if (name.endsWith("'s") || name.endsWith('’s')) return name;
  return `${name}'s`;
};

export const getCollectionDisplayTitle = (
  profile,
  fallbackName = '',
  { forceGenerated = false } = {}
) => {
  const collectionTitle = String(profile?.collection_title || '').trim();

  if (
    !forceGenerated &&
    collectionTitle &&
    !DEFAULT_COLLECTION_TITLES.has(collectionTitle)
  ) {
    return collectionTitle;
  }

  const firstName = firstNameFrom(
    profile?.first_name ||
    fallbackName ||
    profile?.creator_name ||
    profile?.username
  );

  if (firstName) return `From ${possessiveName(firstName)} kitchen`;
  return collectionTitle || 'Recipe Collection';
};

export default getCollectionDisplayTitle;